import { useSignIn, useAuth } from '@clerk/react';
import { useCallback } from 'react';

export { useAuth, useUser, useSignIn } from '@clerk/react'
// Reuse the type definition

export type OAuthStrategy = 'oauth_google' | 'oauth_apple' | 'oauth_microsoft';

interface UseClerkSSOResult {
  isLoaded: boolean;
  signIn: () => Promise<void>;
}

export const getClerkObject = () => window['Clerk'];

export const useClerkSSO = (strategy: OAuthStrategy): UseClerkSSOResult => {
  // Get the global loading state from useAuth()
  const { isLoaded: authIsLoaded } = useAuth();
  
  // Get the signIn object which contains the redirect method
  const { signIn } = useSignIn();

  const handleSignInWithRedirect = useCallback(async () => {

    if (!authIsLoaded || !signIn) {
      return;
    }

    try {
      // Use authenticateWithRedirect for web flows
      // This handles all providers (including Apple on web) automatically
      await signIn.authenticateWithRedirect({
        strategy: strategy,
        // Define your redirect URL for web (e.g., window.location.origin + '/sso-callback')
        // This must be configured in your Clerk Dashboard settings
        redirectUrl: `${window.location.origin}/sso-callback`,
        redirectUrlComplete: `${window.location.origin}/`, // URL after successful sign-in
      });
    } catch (err) {
      // Handle errors during the redirect process
      console.error(`Clerk web SSO error for ${strategy}:`, JSON.stringify(err, null, 2));
    }
  }, [authIsLoaded, signIn, strategy]);

  // The isLoaded status for the component is simply the global auth state
  return { isLoaded: authIsLoaded, signIn: handleSignInWithRedirect };
};
